import { DayJSLocale } from './types'

import { Language } from '../../types'

export const LOCALE_BY_LANGUAGE: {[language in Language]: DayJSLocale} = {
  [Language.EN]: DayJSLocale.EN,
  [Language.ES]: DayJSLocale.ES,
  [Language.FR]: DayJSLocale.FR,
  [Language.PT]: DayJSLocale.PT_BR
}
